// src/modules/app-views/_apps/appmulti/quotations/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  form: {},
  requiredFields: ['destiny'],
};

// *******************************************************************************
// MAIN FUNCTION
// *******************************************************************************
async function seedQuotationsParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];

  // Skip seeding if the module already has any configuration data
  if (moduleParams && Object.keys(moduleParams).length > 0) {
    return [];
  }

  const results = [];

  // Seed form settings
  const formResult = await seedForm({
    moduleId,
    defaultData: DEFAULT_SEEDS.form,
  });
  if (formResult) results.push(formResult);

  // Seed required fields
  const requiredFieldsResult = await seedRequiredFields({
    moduleId,
    defaultData: DEFAULT_SEEDS.requiredFields,
  });
  if (requiredFieldsResult) results.push(requiredFieldsResult);

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedQuotationsParameters;

// *******************************************************************************
// HELPERS
// *******************************************************************************
async function seedForm({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'form',
      moduleId,
      data: defaultData,
    });

    return { category: 'form', seeded: true, data: defaultData };
  } catch (error) {
    return { category: 'form', seeded: false, error };
  }
}

async function seedRequiredFields({ moduleId, defaultData }) {
  try {
    await appService.updateModulePreferences({
      category: 'requiredFields',
      moduleId,
      data: defaultData,
    });

    return { category: 'requiredFields', seeded: true, data: defaultData };
  } catch (error) {
    return { category: 'requiredFields', seeded: false, error };
  }
}
